import { render, staticRenderFns } from "./equipmentImport.vue?vue&type=template&id=673edcc0&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./equipmentImport.vue?vue&type=style&index=0&id=673edcc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673edcc0",
  null
  
)

export default component.exports